import { API_HOST_SCOPE, API_ROOT_ORGS, API_ROOT_USERS, API_ROOT_COMMS } from "../../config";
import { cachingService, LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import { API_ROOT_REFDATA } from "../../config";
import * as RefData from "./business/ReferenceData";
import yesNo from "./json/yesNo.json";

import { OrgsService } from "./business/OrgsService";
import { UserService } from "./business/UserService";
import { ScopeExpansionService } from "./business/ScopeExpansionService";
import { OrgScopesService } from "./business/OrgScopesService";
import { ShareService } from "./business/ShareService";

export const orgsService = new OrgsService(API_ROOT_ORGS);
export const usersService = new UserService(API_ROOT_USERS);
export const scopeExpansionService = new ScopeExpansionService(API_HOST_SCOPE);
export const orgScopesService = new OrgScopesService(API_HOST_SCOPE);
export const shareService = new ShareService(API_ROOT_COMMS);

export const yesNoService = new LocalLookupService(yesNo);
export const qualTypeService = new RefData.RecognitionQualTypeService(
  API_ROOT_REFDATA
);
export const perceivedUnderstandingService = new RefData.EngagementPerceivedUnderstandingOptionsService(
  API_ROOT_REFDATA
);
export const titlesService = new RefData.TitlesService(API_ROOT_REFDATA);
export const countriesService = new RefData.CountryService(API_ROOT_REFDATA);

export const reasonToCloseService = new RefData.EngagementCloseReasonsService(
  API_ROOT_REFDATA
);

export const eventTypeService = new RefData.EngagementEventTypesService(
  API_ROOT_REFDATA
);
export const eventCommunicationTypeService = new RefData.EngagementEventMeansOfCommunicationTypesService(
  API_ROOT_REFDATA
);

export const applicationRejectReasonService = new RefData.RecognitionRejectReasonsService(
  API_ROOT_REFDATA
);

export const legalEntityTypesService = new RefData.LegalEntityTypesService(
  API_ROOT_REFDATA
);

export const applicationPanelDecisionService = new RefData.RecognitionPanelDecisionsService(
  API_ROOT_REFDATA
);

export const applicationReviewMeetingOutcomeService = new RefData.RecognitionApplicationReviewOutcomesService(
  API_ROOT_REFDATA
);

export const applicationReviewOutcomeService = new RefData.RecognitionReviewOutcomesService(
  API_ROOT_REFDATA
);

export const roepaoOptionsService = new RefData.RoEPAOsPresenceOptionsService(
  API_ROOT_REFDATA
);

export const cachedlegalEntityTypesService = cachingService(
  legalEntityTypesService
);
export const cachedCountriesService = cachingService(countriesService);
